module.exports = __webpack_public_path__ + "static/media/ach-verification.1da7f39c.svg";